import HomeIcon from '@mui/icons-material/Home';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { isLegalInfo } from './CookieConsent';
import { useCookies } from '../hooks/CookieProvider';

const StyledStack = styled(Stack)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    gap: theme.spacing(2),
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  'a, button': {
    background: 'none',
    border: 0,
    color: theme.palette.text.secondary,
    font: 'inherit',
    padding: 0,
    textTransform: 'uppercase',
    textDecoration: 'none',
    '&:hover, &:focus-visible': {
      color: theme.palette.text.primary,
    },
    cursor: 'pointer',
  },
}));

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setShowCookieConsent } = useCookies();
  return (
    <StyledStack component="nav" aria-label="Fußnavigation">
      <Link to="/" className="home" aria-label="Startseite" aria-current={location.pathname === '/' ? 'page' : undefined}><HomeIcon fontSize="small" /></Link>
      <Link to="/administration" aria-current={location.pathname === '/administration' ? 'page' : undefined}>Administration</Link>
      <Link to="/software" aria-current={location.pathname === '/software' ? 'page' : undefined}>Software</Link>
      <Link to="/hosting" aria-current={location.pathname === '/hosting' ? 'page' : undefined}>Hosting</Link>
      <Link to="/impressum" aria-current={location.pathname === '/impressum' ? 'page' : undefined}>Impressum</Link>
      <Link to="/datenschutz" aria-current={location.pathname === '/datenschutz' ? 'page' : undefined}>Datenschutz</Link>
      <Link to="/barrierefreiheit" aria-current={location.pathname === '/barrierefreiheit' ? 'page' : undefined}>Barrierefreiheit</Link>
      <button type="button" onClick={() => {
        setShowCookieConsent(true);
        if (isLegalInfo(location)) {
          navigate('/');
        }
      }}>Cookies</button>
    </StyledStack>
  );
};

export default Navigation;
